import React, { useEffect } from 'react';
import './Nav.css';
import $ from 'jquery';

const Nav = () => {

    useEffect(() => {

        $("#btnaboutMe").click(function() {
            $('html, body').animate({
                scrollTop: $("#aboutMe").offset().top
            }, 2000);
        });
        $("#btnwork").click(function() {
            $('html, body').animate({
                scrollTop: $("#work").offset().top
            }, 2000);
        });
        $("#btnblog").click(function() {
            $('html, body').animate({
                scrollTop: $("#blog").offset().top
            }, 2000);
        });
        $("#btncontact").click(function() {
            $('html, body').animate({
                scrollTop: $("#contact").offset().top
            }, 2000);
        });
 
    }, [])

    useEffect(() => {

        $("#btnaboutMe_x").click(function() {
            $('#toggle').removeClass('active');
            $('.overlay').toggleClass('openOverlay');
            $('.right-nav').toggleClass('openRightNav');
            $('html, body').animate({
                scrollTop: $("#aboutMe").offset().top
            }, 2000);
        });
        $("#btnwork_x").click(function() {
            $('#toggle').removeClass('active');
            $('.overlay').toggleClass('openOverlay');
            $('.right-nav').toggleClass('openRightNav');
            $('html, body').animate({
                scrollTop: $("#work").offset().top
            }, 2000);
        });
        $("#btnblog_x").click(function() {
            $('#toggle').removeClass('active');
            $('.overlay').toggleClass('openOverlay');
            $('.right-nav').toggleClass('openRightNav');
            $('html, body').animate({
                scrollTop: $("#blog").offset().top
            }, 2000);
        });
        $("#btncontact_x").click(function() {
            $('#toggle').removeClass('active');
            $('.overlay').toggleClass('openOverlay');
            $('.right-nav').toggleClass('openRightNav');
            $('html, body').animate({
                scrollTop: $("#contact").offset().top
            }, 2000);
        });
 
    }, [])

    useEffect(() => {
        $('#toggle').click(function() {
            $(this).toggleClass('active');
            $('.overlay').toggleClass('openOverlay');
            $('.right-nav').toggleClass('openRightNav');
        });
    }, [])

    useEffect(() => {
        $('.overlay').click(function() {
            $('#toggle').removeClass('active');
            $('.overlay').removeClass('openOverlay');
            $('.right-nav').removeClass('openRightNav');
        });
    }, [])

    return(
        <div className="nav">
            <div id="aboutMe" className="nav-content">
                <div className="nav-logo">
                    <img alt="logo" src="/assets/images/logodiamontdvl.png" />
                </div>
                <ul>
                    <li id="btnaboutMe">O mnie</li>
                    <li id="btnwork">Prace</li>
                    <li id="btnblog">Blog</li>
                    <li id="btncontact">Kontakt</li>
                </ul>
                <div className="button_container" id="toggle">
                    <span className="top"></span>
                    <span className="middle"></span>
                    <span className="bottom"></span>
                </div>
            </div>
            <div className="overlay" id="overlay"></div>
            <div className="right-nav" id="right-nav">
                <ul>
                    <li id="btnaboutMe_x">O mnie</li>
                    <li id="btnwork_x">Prace</li>
                    <li id="btnblog_x">Blog</li>
                    <li id="btncontact_x">Kontakt</li>
                </ul>
            </div>
        </div>
    );
}

export default Nav;